import type { AxiosResponse } from 'axios'

import environment from '@/environments/environment.dev'

import HttpClient from '../apiHttpClient'

const ENDPOINT = '/v1.0/contactreason'
const apiClient = new HttpClient(environment.adminFAPIUrl)

const getContactReasonList = async (
  pageSize: number,
  pageNumber: number,
): Promise<AxiosResponse<unknown>> => {
  return apiClient.get(ENDPOINT, {
    params: {
      pageNumber,
      pageSize,
    },
  })
}

const addContactReason = async (
  contactReasonId: string,
  contactReasonNumber: unknown,
  receiverAddress: unknown,
): Promise<AxiosResponse<unknown>> => {
  return apiClient.post(ENDPOINT, {
    body: {
      contactReasonId,
      indexNumber: String(contactReasonNumber),
      receiverAddress,
    },
  })
}

const editContactReason = async (
  contactReasonId: string,
  contactReasonNumber: unknown,
  receiverAddress: unknown,
): Promise<AxiosResponse<unknown>> => {
  return apiClient.put(ENDPOINT, {
    body: {
      contactReasonId,
      indexNumber: String(contactReasonNumber),
      receiverAddress,
    },
  })
}

const deleteContactReason = async (
  contactReasonId: string,
): Promise<AxiosResponse<unknown>> => {
  return apiClient.delete(ENDPOINT, {
    params: {
      contactReasonId,
    },
  })
}

export const adminFapiContactReason = {
  getContactReasonList,
  addContactReason,
  editContactReason,
  deleteContactReason,
}
